import { cx } from '../lib/format'

/**
 * Traced from the supplied Altair artwork into transparent SVG by
 * `npm run logo`, so it stays sharp at any size on any background.
 */
export function Logo({
  variant = 'light',
  className,
  height = 26,
}: {
  variant?: 'light' | 'dark'
  className?: string
  height?: number
}) {
  return (
    <img
      src={variant === 'light' ? '/altair-logo-light.svg' : '/altair-logo.svg'}
      alt="Altair"
      style={{ height }}
      className={cx('w-auto select-none', className)}
      draggable={false}
    />
  )
}

export function LogoMark({ className, size = 22 }: { className?: string; size?: number }) {
  return (
    <img
      src="/altair-mark.svg"
      alt=""
      width={size}
      height={size}
      className={cx('select-none', className)}
      draggable={false}
    />
  )
}

export function Wordmark({
  variant = 'light',
  subtitle,
  height = 24,
}: {
  variant?: 'light' | 'dark'
  subtitle?: string
  height?: number
}) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <Logo variant={variant} height={height} />
      {subtitle ? (
        <>
          <span
            className={cx(
              'hidden h-6 w-px sm:block',
              variant === 'light' ? 'bg-white/15' : 'bg-slate-300',
            )}
            aria-hidden
          />
          <span
            className={cx(
              'hidden truncate text-[12.5px] font-semibold uppercase tracking-[0.16em] sm:inline',
              variant === 'light' ? 'text-slate-400' : 'text-slate-600',
            )}
          >
            {subtitle}
          </span>
        </>
      ) : null}
    </div>
  )
}
